<div id="modal-container">
  <table id="search-add-tbl">
    <tr style="height: fit-content">
      <th class="search">
        <app-ticker-search
          [isComp]="true"
          (tickerToEmit)="addSearchedTicker($event)"
        ></app-ticker-search>
      </th>
      <th>{{ "Selected Companies(up to " + max + "):" }}</th>
    </tr>
    <tr>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.visibility]="watchlistData.length ? 'visible' : 'hidden'"
          >
            <div
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="menu"
              [ngClass]="{ active: visible }"
              (nzVisibleChange)="onMenuVisibleChange($event)"
              [nzOverlayClassName]="'comp-menu-dropdown'"
              [nzBackdrop]="false"
              id="selectedItem"
            >
              <span
                style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis"
                >{{ selectedMenuItem }}</span
              >
              <i
                nz-icon
                nzType="down"
                style="float: right; margin-left: 5px; margin-top: 5px"
              ></i>
            </div>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu class="menu-holder">
                <li
                  nz-menu-item
                  *ngFor="let data of watchlistData"
                  (click)="onWatchlistSelect($event, data)"
                  [title]="data.watchername"
                  style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis"
                >
                  {{ data.watchername }}
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div class="right-heading-add" (click)="addAllTickers()">
            <va-icon size="small" name="plus" class="icon va-icon"></va-icon>Add All
          </div>
        </div>
        <app-add-modal-section
          [dataToUse]="recentlyVisited"
          field="name"
          company="ticker"
          (addData)="addTicker($event)"
          [maxHeight]="maxHeight"
        ></app-add-modal-section>
      </td>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.color]="
              modalData.length > max || modalData.length < 1
                ? '#e61F00'
                : '#363636'
            "
          >
            Number of selected: {{ modalData && modalData.length }}
          </div>
          <div
            [ngClass]="[
              modalData && modalData.length
                ? 'right-heading-remove'
                : 'greyed-removeall'
            ]"
            (click)="removeAllTickers()"
          >
            <va-icon size="small" name="close" class="icon va-icon"></va-icon>Remove All
          </div>
        </div>
        <app-remove-modal-section
          [dataToUse]="modalData"
          field="name"
          company="ticker"
          [maxHeight]="maxHeight"
          (removeData)="removeTicker($event)"
        ></app-remove-modal-section>
      </td>
    </tr>
  </table>

  <!-- <div *nzModalFooter>
              <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
              <button
                nz-button
                nzType="primary"
                [ngClass]="this.modalData.length > 20 ? 'disable-btn' : ''"
                (click)="updateTickers()"
                [disabled]=" this.modalData.length === 0? true : false"
                [title]="this.modalData.length > 20 ? 'Max number of tickers is 50' : ''"
              >
                Update
              </button>
            </div> -->
</div>
